
const digest = 'c3bb1314e63135951c9dca1f74b36d452ea0d792d5781ce18dcc002ec9abdd36';
const classes = {"wrapper":"_wrapper_1yo71_1","loadingWrapper":"_loadingWrapper_1yo71_9"};
const css = `._wrapper_1yo71_1 {
  background: #ffffff;
  border-radius: 15px;
  padding: 40px;
  min-height: calc(100vh - 160px);
  display: flex;
}

._loadingWrapper_1yo71_9 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  